
import anime from "animejs"
import Vue from "vue"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import Component from "vue-class-component"
import superScoreToArray from "@avantek/commons-js/superscore/superScoreToArray"
import {Prop} from "vue-property-decorator"
import {MetricAggregated} from "@/cube/metric-data"
import HelpIcon from "@/ui/HelpIcon.vue"
import SuperScoreStar from "@avantek/commons-js/superscore/SuperScoreStar/SuperScoreStar.vue"

@Component({components: {ChangeRateWidget, HelpIcon, SuperScoreStar: <any>SuperScoreStar}})
export default class PlanSuperScoreWidget extends Vue {
  @Prop()
  metricData: MetricAggregated

  @Prop({default: false})
  report: boolean

  animatedScore = 0

  get planSuperScoreAsStars() {
    const superScorePoints = this.animatedScore
    return superScoreToArray(superScorePoints)
  }

  mounted() {
    this.$watch(
      () => this.metricData.end,
      () => {
        anime({
          targets: this,
          animatedScore: this.metricData.end?.amount,
          round: 10,
          easing: "linear",
        })
      }
    )
  }
}
